import {
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  styled,
  Flex,
} from '@grupoboticario/flora-react';

export const styles = {
  FullFlex: styled(Flex, {
    width: '100%',
  }),
  DrawerHeader: styled(DrawerHeader, {
    backgroundColor: '$backgroundPrimary',
  }),
  DrawerBody: styled(DrawerBody, {
    '&[data-flora="drawer-body"]': {
      padding: '0',
    },
  }),

  DrawerCloseButton: styled(DrawerCloseButton, {
    cursor: 'pointer',
  }),

  DrawerContent: styled(DrawerContent, {
    backgroundColor: '$backgroundSecondary',
    '@tablet': {
      minWidth: 'calc($20 * 6)',
    },
  }),
  DrawerSection: styled(Flex, {
    backgroundColor: '$backgroundPrimary',
    width: '100%',
    marginTop: '$4',
    padding: '$4 $7',
    flexDirection: 'column',
    gap: '$2',
  }),
};

export default styles;
